// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".maplibregl-ctrl button{border-radius:unset}.maplibregl-popup-close-button{display:none!important}.maplibregl-popup{max-width:unset!important;font-size:0}.maplibregl-content{width:-moz-fit-content;width:fit-content}.mapboxgl-popup-content{padding:unset;background:none}.maplibregl-popup-tip{border-top-color:#61a60e!important;border-bottom-color:#61a60e!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
